// @flow
import {
    configureWebPushSubscription,
    fetchNotificationsIfNeeded,
    forceEnableNotificationsBanner,
    getBrowserPermission,
    getHasActiveSubscription,
    getHasNewNotifications,
    getIsLoading,
    getNeedsSubscription,
    getNotificationCount,
    getNotifications,
    getPermission,
    getPushNotifications,
    getShowPermissionsOverlay,
    markNotificationsDeleted,
    markNotificationsRead,
    openMobileDownloadModal,
    requestBrowserPermission,
    setPermission,
} from '../../../redux/modules/notification';
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAuthToken } from '../../../redux/modules/user';
import isEqual from 'react-fast-compare';
import NotificationDropDown from './NotificationDropDown';
import Overlay from './Overlay';
import PushNotificationsContainer from './PushNotificationsContainer';
import { trackDesktopNotificationsView } from '../../../redux/modules/analytics';

const mapStateToProps = state => {
    const token = getAuthToken(state);
    const hasActiveSubscription = getHasActiveSubscription(state);
    const hasNewNotifications = getHasNewNotifications(state);
    const loading = getIsLoading(state);
    const needsSubscription = getNeedsSubscription(state);
    const notificationCount = getNotificationCount(state);
    const notifications = getNotifications(state);
    const permission = getPermission(state);
    const pushNotifications = getPushNotifications(state);
    const showPermissionsOverlay = getShowPermissionsOverlay(state);

    return {
        hasActiveSubscription,
        hasNewNotifications,
        hasToken: Boolean(token),
        loading,
        needsSubscription,
        notificationCount,
        notifications,
        permission,
        pushNotifications,
        showPermissionsOverlay,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            configureWebPushSubscription,
            fetchNotificationsIfNeeded,
            forceEnableNotificationsBanner,
            getBrowserPermission,
            markNotificationsDeleted,
            markNotificationsRead,
            openMobileDownloadModal,
            requestBrowserPermission,
            setPermission,
            trackDesktopNotificationsView,
        },
        dispatch
    );

type Props = {
    configureWebPushSubscription: Function,
    fetchNotificationsIfNeeded: Function,
    forceEnableNotificationsBanner: Function,
    getBrowserPermission: Function,
    hasActiveSubscription: boolean,
    hasNewNotifications: boolean,
    hasToken: boolean,
    loading: boolean,
    markNotificationsDeleted: Function,
    markNotificationsRead: Function,
    mobile: string,
    needsSubscription: boolean,
    notificationCount: number,
    notifications: any[],
    openMobileDownloadModal: Function,
    parent: any,
    pathname: string,
    permission: string,
    pushNotifications: any[],
    requestBrowserPermission: Function,
    setPermission: Function,
    showPermissionsOverlay: boolean,
    trackDesktopNotificationsView: Function,
};

class NotificationsContainer extends Component<Props> {
    componentDidMount() {
        this.props.needsSubscription && this.props.configureWebPushSubscription();
    }

    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    componentDidUpdate() {
        this.props.fetchNotificationsIfNeeded();
        this.props.needsSubscription && this.props.configureWebPushSubscription();
    }

    trackView = () => {
        this.props.trackDesktopNotificationsView();
    };

    render() {
        const {
            forceEnableNotificationsBanner,
            getBrowserPermission,
            mobile,
            markNotificationsDeleted,
            markNotificationsRead,
            notifications,
            notificationCount,
            openMobileDownloadModal,
            parent,
            permission,
            pushNotifications,
            requestBrowserPermission,
            setPermission,
            showPermissionsOverlay,
        } = this.props;

        return (
            <Fragment>
                <Overlay show={showPermissionsOverlay} />
                <PushNotificationsContainer
                    notifications={pushNotifications}
                    permission={permission}
                    getBrowserPermission={getBrowserPermission}
                    setPermission={setPermission}
                />
                <NotificationDropDown
                    forceEnableNotificationsBanner={forceEnableNotificationsBanner}
                    mobile={mobile}
                    markNotificationsDeleted={markNotificationsDeleted}
                    markNotificationsRead={markNotificationsRead}
                    notificationCount={notificationCount}
                    notifications={notifications}
                    openMobileDownloadModal={openMobileDownloadModal}
                    parent={parent}
                    permission={permission}
                    placement="bottom"
                    popover
                    requestBrowserPermission={requestBrowserPermission}
                    setPermission={setPermission}
                    trackView={this.trackView}
                />
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer);
